module.exports = __webpack_public_path__ + "img/ajax.2556ef6c.svg";